import { setAlert } from "../alert";
import Axios from "axios";
import { GET_MISC_CONTRACT, REMOVE_MISC_CONTRACT } from "../../types";

/**
 * @string  getMiscContract
 * @param   {Number} id
 */
export const getMiscContract = id => async dispatch => {
    try {
        if (!id) {
            return;
        }
        const response = await Axios.get(`/api/automobiles/contract?id=${id}`);

        dispatch({
            type: GET_MISC_CONTRACT,
            payload: response.data
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

export const getMiscContractByCode = code => async dispatch => {
    try {
        if (!code) {
            return;
        }
        const response = await Axios.get(
            `/api/automobiles/contract?code=${code}`
        );

        dispatch({
            type: GET_MISC_CONTRACT,
            payload: response.data
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name	removeMiscContract
 */
export const removeMiscContract = () => async dispatch => {
    try {
        dispatch({ type: REMOVE_MISC_CONTRACT });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};